import './styles.scss';
import Label from 'components/Label';
import './styles.scss'
import Table from 'components/Table';
import { useSelector } from 'react-redux';
import { selectCurrentLocationsLocations } from 'store/slices/LocationsSlice';
import { useRef } from 'react';
import { useAnimation } from 'hooks/useAnimation';
const CurrentLocationTable = ({ isLoading }) => {
    const container = useRef();
    const proxyLocations = useSelector(selectCurrentLocationsLocations)
    const { tag, title, proxy_table } = proxyLocations

    const columns = [
        { Header: 'City', accessor: 'city' },
        { Header: 'IP Count', accessor: 'ip_count' },
        { Header: 'Protocols', accessor: 'protocols' },
        { Header: 'IP Version', accessor: 'ip_version' },
        { Header: 'Bandwidth', accessor: 'bandwidth' },
    ];


    useAnimation({
        items: ['.location-table h2', '.table-container'],
        container,
        dependencies: [isLoading],
    })

    if (!proxy_table) {
        return null;
    }

    return (
        <section ref={container} className='inner-container location-table'>
            <Label text={tag} />
            <h2>{title}</h2>
            <Table data={proxy_table} columns={columns} />
        </section>
    );
};

export default CurrentLocationTable;
